module.exports = __webpack_public_path__ + "static/media/ticket-icon.a27621fa.svg";